module.exports = __webpack_public_path__ + "static/media/css.1a50a159.pdf";